var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "newsletterForm",
      staticClass: "heista_newsletter",
      attrs: { id: "newsletter-input-form_" + _vm._uid, method: "post" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.validateData($event)
        },
      },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-9 mx-auto" }, [
          _vm.showNameInputs
            ? _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "input-unit",
                    attrs: { "data-validate": "!regex" },
                  },
                  [
                    _c(
                      "label",
                      { attrs: { for: "first-name-input_" + _vm._uid } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.newsletterFirstName"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.firstName,
                          expression: "firstName",
                        },
                      ],
                      attrs: {
                        type: "text",
                        "data-validate-ref": "/[.:\\/\\d]/g",
                        id: "first-name-input_" + _vm._uid,
                        "data-testing": "nl-first-name",
                      },
                      domProps: { value: _vm.firstName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.firstName = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showNameInputs
            ? _c("div", { staticClass: "col-6 pl-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "input-unit",
                    attrs: { "data-validate": "!regex" },
                  },
                  [
                    _c(
                      "label",
                      { attrs: { for: "last-name-input_" + _vm._uid } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.newsletterLastName")
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lastName,
                          expression: "lastName",
                        },
                      ],
                      attrs: {
                        type: "text",
                        "data-validate-ref": "/[.:\\/\\d]/g",
                        id: "last-name-input_" + _vm._uid,
                        "data-testing": "nl-last-name",
                      },
                      domProps: { value: _vm.lastName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.lastName = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "input-group input-area" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit flex-fill",
                  attrs: { "data-validate": "mail" },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    staticClass: "input-newsletter",
                    attrs: {
                      type: "email",
                      autocomplete: "email",
                      id: "email-input-id_" + _vm._uid,
                      "data-testing": "nl-mail",
                      placeholder: _vm.$translate(
                        "ZeitloungeTheme::Template.newsletterPlaceholder"
                      ),
                    },
                    domProps: { value: _vm.email },
                    on: {
                      focus: function ($event) {
                        _vm.loadRecaptcha = true
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-block btn-newsletter",
                  class: _vm.buttonSizeClass,
                  attrs: {
                    type: "button",
                    disabled: _vm.isDisabled,
                    "data-testing": "nl-send",
                  },
                  on: { click: _vm.validateData },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$translate(
                          "Ceres::Template.newsletterSubscribeButtonLabel"
                        )
                      ) +
                      "\n\t\t\t\t\t\t"
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.honeypot,
                    expression: "honeypot",
                  },
                ],
                staticClass: "honey",
                attrs: {
                  autocomplete: "none",
                  type: "text",
                  name: "username",
                  tabindex: "-1",
                },
                domProps: { value: _vm.honeypot },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.honeypot = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _vm.showPrivacyPolicyCheckbox
            ? _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-check small form-info-check",
                    attrs: { "data-validate": "" },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.privacyPolicyValue,
                          expression: "privacyPolicyValue",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "checkbox",
                        id: "privacy-policy-accept-id_" + _vm._uid,
                        name: "privacy-policy-accept",
                        "data-testing": "nl-policy",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.privacyPolicyValue)
                          ? _vm._i(_vm.privacyPolicyValue, null) > -1
                          : _vm.privacyPolicyValue,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.privacyPolicyValue,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.privacyPolicyValue = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.privacyPolicyValue = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.privacyPolicyValue = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", {
                      staticClass: "form-check-label",
                      attrs: { for: "privacy-policy-accept-id_" + _vm._uid },
                      domProps: { innerHTML: _vm._s(_vm.privacyPolicyText) },
                    }),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 text-right small mt-2" }, [
            _vm._v(
              _vm._s(
                _vm.$translate("Ceres::Template.newsletterIsRequiredFootnote")
              ) +
                " " +
                _vm._s(_vm.$translate("Ceres::Template.newsletterIsRequired"))
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      !!_vm.$ceres.config.global.googleRecaptchaApiKey && _vm.loadRecaptcha
        ? _c("recaptcha")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }